import pickBy from "lodash/pickBy";
import { useBookingModuleStore, useCalendarRoot, useCalendarRootActions } from "PFApp/booking/store";
import { isProjects } from "PFApp/booking/utils/calendar_root.utils";
import { useOnFiltersUpdate } from "PFApp/components/filters_v2";

export const useResetRootRowsState = () => {
  const calendarRoot = useCalendarRoot();
  const rows = useBookingModuleStore((state) => state[calendarRoot].rows);
  const pinnedIds = useBookingModuleStore((state) => state[calendarRoot].pinnedIds);
  const expandedRowsState = useBookingModuleStore((state) => state[calendarRoot].expandedRowsState);
  const paginationByRowKey = useBookingModuleStore((state) => state[calendarRoot].paginationByRowKey);
  const allBookingsModeRowsState = useBookingModuleStore((state) =>
    isProjects(calendarRoot) ? state[calendarRoot].allBookingsModeRowsState : null
  );
  const setAllBookingsModeRowsState = useBookingModuleStore((state) =>
    isProjects(calendarRoot) ? state.actions[calendarRoot].setAllBookingsModeRowsState : null
  );
  const { setExpandedRowsState, setPaginationByRowKey } = useCalendarRootActions(calendarRoot);

  useOnFiltersUpdate(() => {
    // reset expanded state, all bookings mode state and children pagination except for pinned rows
    const pinnedRowKeys = rows
      .filter(({ original }) => pinnedIds.includes(original.id as number))
      .map(({ key }) => key);

    const pinnedExpandedState = pickBy(expandedRowsState, (value, key) =>
      pinnedRowKeys.some((pinnedKey) => key.includes(pinnedKey))
    );
    const pinnedAllBookingsModeRowsState = pickBy(allBookingsModeRowsState, (value, key) =>
      pinnedRowKeys.some((pinnedKey) => key.includes(pinnedKey))
    );
    const pinnedPaginationByRowKey = pickBy(paginationByRowKey, (value, key) =>
      pinnedRowKeys.some((pinnedKey) => key.includes(pinnedKey))
    );

    setPaginationByRowKey(pinnedPaginationByRowKey);
    setExpandedRowsState(pinnedExpandedState);
    isProjects(calendarRoot) && setAllBookingsModeRowsState?.(pinnedAllBookingsModeRowsState);
  });
};
